/**
 * List Schema of TipoOcorrencia
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {TipoOcorrencia} from '@/model/resource/TipoOcorrencia'

export class ListTipoOcorrenciaSchema extends Schema {
  readonly name = 'ListTipoOcorrencia'

  readonly fieldSet: FieldSet<TipoOcorrencia> = {
    idOcorrenciaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
    ehDevolvida: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ehDevolvida),
      },
    }),
  }
}
